import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer, LabelList
} from 'recharts';
import { formatDate } from '../../../exportreport/utils';





const CustomLineChart = ({ theme, data, isWeekly , XAxisFont=18, YAxisFont=18, height=300, formatter}) => {
  // Calculate the minimum and maximum values
  const minValue = Math.min(...data.map(d => d.value));
  const maxValue = Math.max(...data.map(d => d.value));
  
  // Calculate 20% below the min value and 20% above the max value
  const buffer = (maxValue - minValue) * 0.2;
  const adjustedMin = Math.floor(minValue - buffer); // Round down
  const adjustedMax = Math.ceil(maxValue + buffer);  // Round up
  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={{ top: 10, right: 0, left: 10, bottom: 50 }}>
        <XAxis 
          dataKey="date" 
          tick={{ fill: theme === "dark" ? "#f8ffef" : 'rgb(102, 102, 102)',  fontWeight: 600,fontSize: XAxisFont }} 
          axisLine={{ stroke: theme === "dark" ? "#f8ffef" : '#eee' }} 
          tickLine={false} 
          interval={0} 
          angle={-45} 
          textAnchor="end"
          padding={{ left: 20, right: 20 }}  
          height={50}
        />
        <YAxis 
          tick={{ fill: theme === "dark" ? "#f8ffef" : 'rgb(102, 102, 102)',  fontWeight: 600,fontSize: YAxisFont, dx: 5 }} 
          axisLine={{ stroke: theme === "dark" ? "#f8ffef" : '#eee' }} 
          tickLine={false} 
          tickCount={8}
          domain={[adjustedMin, adjustedMax]}
          tickFormatter={formatter}
        />
        <Line 
          type="monotone" 
          dataKey="value" 
          className="line-chart-element"
          strokeWidth={4} 
          dot={false}
          strokeLinecap="butt"  
        >
        </Line>
      </LineChart>
    </ResponsiveContainer>
  );
};

export default CustomLineChart;
